<template>
<div id="app-vue" :class="{'ustawoteka': APP_MODE === APP_USTAWOTEKA}">
	<v-app>
		<v-main>
			<RouterView />
		</v-main>
	</v-app>
</div>
</template>

<script setup lang="ts">
import { onMounted, watch } from '@vue/runtime-core';
import { RouterView } from 'vue-router';
import { APP_MODE, APP_USTAWOTEKA } from '@/config/appModel';

// Ponizej zrobiona funkcjonalnosc do customowych kolorow paska bocznego w zaleznosci od tego na ktorej apce jestesmy
const updateHtmlClass = (enabled: boolean) => {
	document.documentElement.classList.toggle('ustawoteka', enabled);
};

onMounted(() => {
	updateHtmlClass(APP_MODE === APP_USTAWOTEKA);
});

watch(
	() => APP_MODE,
	(mode) => {
		updateHtmlClass(mode === APP_USTAWOTEKA);
	}
);
</script>

<style lang="scss">
@import 'assets/scss/app';
</style>
